var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex bg-light border rounded px-2 py-1 mb-1 small align-items-center"},[_c('div',[_vm._v(_vm._s(_vm.info))]),_c('b-link',{staticClass:"ml-1",on:{"click":function($event){$event.preventDefault();return _vm.close()}}},[_c('i',{staticClass:"bi-x-circle-fill"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }